var klevu_uc = {
  /**
   * fundtion for showing poduct cells on search landing page
   */
  showLandingPageData: function (product) {
	//get vip price
  	var vippercentagestr = "";
    var viptagarray = product.tags.split(',');
    var vipsalemultiplier = 0;
    for(var b = 0; b < viptagarray.length; b++){
      if(viptagarray[b].indexOf("VIPSale") > -1){
    	vippercentagestr = viptagarray[b].split(' ')[2];
    	vipsalemultiplier = 1 - (parseInt(vippercentagestr) / 100);
        break;
	  }
    }

    var toReturn = '',
      toAppendwithSalePrice = '',
      priceWithCurrency = '',
      appendCurrencyAtLast = false,
      salepriceClass = 'kuSalePrice',
      priceFormatter, priceToSet,
      showToLabel = false,
      additionalParams = '',
      keywords = document.getElementById('searchedKeyword').value,
      trackingParams = "",
      trackingEventHtml = "",
      i = 0,
      j = 0,
      currentSwatch, swatchEventHandlerHtml,
      swatchFocusHandler, swatchBlurHandler, swatchColor,
      swatchCount = 0,
      swatchesShown = false,
      swatchesHtml = "",
      totalSwatchesToShow = 5,
      validSwatch = true,
      swatchGradientCSS = '',
      imgAlt, imgAltDiv = document.createElement('div');

    product = klevu_productCustomizations(product);
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }
    
    product.productUrl = product.productUrl + "?subnav=Search";

    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
    }
    trackingParams = '{' +
      'data: {' +
      'code: \'' + escape(product.productCode) + '\',' +
      'url: \'' + escape(product.productUrl) + '\',' +
      'name: \'' + escape(product.productName) + '\',' +
      'salePrice: \'' + escape(product.salePrice) + '\',' +
      'rating: \'' + escape(product.rating) + '\',' +
      'position: ' + product.productPosition + ',' +
      'category: \'' + escape(product.category) + '\',' +
      'sku: \'' + escape(product.sku) + '\'' +
      '},' +
      'apiKey: null,' +
      'keywordsLP: \'' + escape(keywords) + '\'' +
      '}';

    if (klevu_commons.isMobileDevice()) {
      trackingEventHtml = ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
    } else {
      trackingEventHtml = ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + trackingParams + ', klevu_analytics.trackClickedProduct);" ' + additionalParams + '>';
    }
    try {
      // code for the result block
      toReturn += '<li>';

      //PRODUCT THUMBNAIL
      toReturn += '<div class="klevuImgWrap">';
      toReturn += '<a href="' + product.productUrl.replace(/"/g, "%22") + '" ';
      if (klevu_userOptions.showRolloverImage && product.imageHover) {
        toReturn += ' onmouseleave = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');" ' +
          ' onmouseenter = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.imageHover) + '\', \'klevuProductImage-' + product.id + '\');" ';
      }
      imgAltDiv.innerHTML = product.productName;
      imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";
      toReturn += ' target="_blank" ' + trackingEventHtml +
        '<img id= "klevuProductImage-' + product.id + '" src="' + product.productImage + '" onerror="this.onerror=null;this.src=\'' +
        klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '"/>';

      toReturn += '</a></div>'; //closing image wrap

      // PRODUCT SWATCHES
      if (klevu_userOptions.showProductSwatches && product.swatches && product.swatches.swatch && product.swatches.swatch.length > 0) {
        totalSwatchesToShow = product.swatches.swatch.length > totalSwatchesToShow ? totalSwatchesToShow : product.swatches.swatch.length;
        for (i = 0; i < totalSwatchesToShow; i++) {
          currentSwatch = product.swatches.swatch[i];
          if (currentSwatch.image) {
            swatchesShown = true;
            //currentSwatch.swatchImage = "#73ae00;#ae0073;#0073ae";
            if (currentSwatch.swatchImage && currentSwatch.swatchImage.indexOf("#") === 0) {
              swatchColor = currentSwatch.swatchImage.split(";");
              currentSwatch.swatchImage = '';
            } else {
              swatchColor = currentSwatch.color.replace(/ /g, "").replace(/-/g, "");
            }
            validSwatch = true;

            if ("object" === typeof swatchColor) {
              for (j = 0; j < swatchColor.length; j++) {
                if (swatchColor[j] && !klevu_commons.isValidCSSColor(swatchColor[j])) {
                  validSwatch = false;
                  break;
                }
              }
            } else {
              if (!currentSwatch.swatchImage && !klevu_commons.isValidCSSColor(swatchColor)) {
                validSwatch = false;
              }
              if (!klevu_commons.isValidCSSColor(swatchColor)) {
                swatchColor = '';
              }
            }

            if (!validSwatch) {
              swatchesHtml += '<div class="klevuSwatchItem klevuDefaultSwatch">';
            } else {
              swatchesHtml += '<div class="klevuSwatchItem">';
            }

            swatchFocusHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(currentSwatch.image) + '\', \'klevuProductImage-' + product.id + '\');';
            swatchBlurHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');';
            if (klevu_commons.isMobileDevice()) {
              swatchEventHandlerHtml = ' onclick = "' + swatchFocusHandler + '" ';
            } else {
              swatchEventHandlerHtml = ' onmouseleave = "' + swatchBlurHandler + '" onmouseenter = "' + swatchFocusHandler + '" ';
            }

            swatchesHtml += '<a href = "javascript:void(0);" class = "klevuSwatchLink" ' + swatchEventHandlerHtml;
            if ("object" === typeof swatchColor) {
              var colorPercent = 100.00 / swatchColor.length;
              swatchGradientCSS = 'linear-gradient(-45deg,';
              for (j = 0; j < swatchColor.length; j++) {
                if (j === 0) {
                  swatchGradientCSS += ' ';
                } else {
                  swatchGradientCSS += ', ';
                }
                swatchGradientCSS += swatchColor[j] + ' ' + (colorPercent * j) + '%';
                swatchGradientCSS += ', ' + swatchColor[j] + ' ' + (colorPercent * (j + 1)) + '%';
              }
              swatchGradientCSS += ' );';

              swatchesHtml += ' style = "background-image: ' + swatchGradientCSS +
                'background-image: -webkit-' + swatchGradientCSS +
                'background-image: -moz-' + swatchGradientCSS +
                'background-image: -o-' + swatchGradientCSS +
                'background-image: -ms-' + swatchGradientCSS +
                '" title="' + currentSwatch.color + '">';
            } else {
              swatchesHtml += ' style = "background-color:' + swatchColor +
                '; background-image:url(\'' + currentSwatch.swatchImage + '\');" title="' + currentSwatch.color + '">';
            }

            swatchesHtml += '</a></div>';
          } else {
            swatchCount += 1;
          }
        }
        if (product.swatches.swatch.length > totalSwatchesToShow) {
          swatchCount += product.swatches.swatch.length - totalSwatchesToShow;
        }
        if (!swatchesShown) {
          swatchesHtml = '<div class="klevuSwatches" style="display:none;">' + swatchesHtml;
        } else {
          swatchesHtml = '<div class="klevuSwatches">' + swatchesHtml;
        }
        swatchCount += (product.swatches.numberOfAdditionalVariants ? +(product.swatches.numberOfAdditionalVariants) : 0);
        if (swatchCount > 0 && swatchesShown) {
          swatchesHtml += '<div class = "klevuSwatchItem klevuSwatchMore">' +
            '<a href = "' + product.productUrl.replace(/"/g, "%22") + '" class = "klevuSwatchLink"' + trackingEventHtml +
            '<span class = "klevuSwatchMoreText">+' + swatchCount + '</span></a></div>';
        }

        swatchesHtml += '</div>';
        toReturn += swatchesHtml;
      }
    } catch (e) {}

    // DISCOUNT BADGE
    if ('undefined' !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge && product.discount != '' &&
      product.discount != '0' && product.discount != '0.0') {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText + ' ' +
          Number(product.discount).toFixed(0) +
          '%</div>';
      } else {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
          '</div>';
      }
    }
    toReturn += '<div class="kuNameDesc">';

    // PRODUCT NAME
    toReturn += '<div class="kuName"><a href="' + product.productUrl.replace(/"/g, "%22") +
      '" target="_blank" ' + trackingEventHtml;
    toReturn += product.productName + '</a></div>';

    // PRODUCT DESCRIPTION
    toReturn += '<div class="kuDesc">' + product.productDescription + '</div>';

    // PRODUCT RATING
    if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
      Number(product.rating) <= 5 && Number(product.rating) >= 0) {
      var starWidth = 20 * Number(product.rating);
      toReturn += '<div class="kuStarsSmall">' +
        '<div class="kuRating" style="width:' + starWidth +
        '%;"></div></div>';
    }
    toReturn += '</div>';

    // PRODUCT PRICE
    if(peValidateVIP() && vipsalemultiplier != 0){
        var vipmardownprice = product.salePrice * vipsalemultiplier;
        toReturn += '<div class="kuPrice">';
        toReturn += '<span class="klevu-saleprice-l2">'
        toReturn += '<span class="klevuPriceGreyText-l2" style="text-decoration: line-through;">&pound;' + product.salePrice + '</span>';
        toReturn += '<span style="color:red;margin-left:5px;">&pound;' + vipmardownprice.toFixed(2) + '</span>';
        toReturn += '</span>';
        toReturn += '</div>';
    }
    else{
      toReturn += '<div class="kuPrice ge-hide">';
      if (klevu_showPrices) {
        if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
          toReturn += klevu_commons.showOriginalAndSalePrices('LANDING', product,
            salepriceClass, 'kuSalePrice kuSpecialPrice');
        } else {
          toReturn += klevu_commons.showProductPrices('LANDING', product,
            salepriceClass, 'kuSalePrice kuSpecialPrice');
        }
      }
    }

    // VAT CAPTION
    if (klevu_userOptions.vatCaption.trim().length > 0) {
      toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
    }

    // PRODUCT VARIANT COUNT
    if (product.totalProductVariants && product.totalProductVariants != '0' && !swatchesShown) {
      if (klevu_uiLabels.variants.indexOf("#") === -1) {
        toReturn += '<div class="klevu-variants">+' + product.totalProductVariants +
          ' ' + klevu_uiLabels.variants + '</div>';
      } else {
        toReturn += '<div class="klevu-variants">' +
          klevu_uiLabels.variants.replace("#", product.totalProductVariants) + '</div>';
      }
    }

    // OUT OF STOCK LABEL
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if ((product.inStock) && product.inStock === 'no') {
        toReturn += '<div class="klevu-out-of-stock">' +
          klevu_userOptions.outOfStockCaption + '</div>';
      }
    }

    toReturn += '</div>';

    // ADD TO CART
    if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
      if (!(product.isCustomOptionsAvailable && product.isCustomOptionsAvailable === "yes") &&
        (!product.totalProductVariants || product.totalProductVariants == '0')) {
        toReturn += '<div class="kuAddtocart">' +
          '<label for="klevu-qty-' + escape(product.productCode) + '" style="display:none;">&nbsp;</label>' +
          '<input type="text" name="klevu-qty" id="klevu-qty-' +
          escape(product.productCode) + '" placeholder="' +
          klevu_uiLabels.addToCartPlaceholder + '"/>' +
          '<a href="javascript:klevu_lpSendProductToCart(\'' +
          escape(product.productCode) + '\', \'' +
          escape(product.productUrl) + '\', \'klevu-qty-' +
          escape(product.productCode) + '\');" ' +
          'class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
          '</div>';
      } else {
        toReturn += '<div class="kuAddtocart">' +
          '<a href="' + product.productUrl.replace(/"/g, "%22") +
          '" class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
          '</div>';
      }
      toReturn += '<div class="klevu-clearboth-listview"></div>';
    }
    toReturn += '<div class="kuClearLeft"></div>';
    toReturn += '</li>';

    return toReturn;
  },

  /**
   * function for showing no-results data on landing page
   */
  showLandingPageNoResultData: function (noResultsData) {
    var noResultsHtml = '',
      maxNoOfChars = 33,
      products = noResultsData.products || [],
      noResultsOptions = klevu_userOptions.noResultsOptions,
      showPopularKeywords = false,
      imgAlt, imgAltDiv = document.createElement('div');

    noResultsHtml += '<div class="kuNoResults-lp">';
    noResultsHtml += '<div class="kuNoResultsInner">';
    noResultsHtml += '<div class="kuNoResults-lp-message">' + noResultsData.msgToShow + '</div>';

    if (products && products.length > 0) {

      noResultsHtml += '<div class="kuNoResults-lp-relatedProducts">';
      noResultsHtml += '<h3 class="kuNoResults-lp-title">' + noResultsData.headingForNoResultProducts + '</h3>';
      noResultsHtml += '<ul class="kuNoResults-lp-relatedProduct-list">';

      for (var i = 0; i < products.length; i++) {
        noResultsHtml += '<li>';
        noResultsHtml += '<a href="' + products[i].url + '" class="kuRelatedProductbox-lp"';
        if (klevu_commons.isMobileDevice()) {
          noResultsHtml += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + noResultsData.trackingParams[i] + ');"  >';
        } else {
          noResultsHtml += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + noResultsData.trackingParams[i] + ');" ' +
            ' onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + noResultsData.trackingParams[i] + ', klevu_analytics.trackClickedProduct);" ' +
            noResultsData.additionalParams + ' >';
        }

        if (('undefined' === typeof klevu_truncateDescription ||
            ('undefined' !== typeof klevu_truncateDescription && klevu_truncateDescription)) &&
          products[i].desc.length > maxNoOfChars) {
          products[i].desc = products[i].desc.replace(/^(.{33}[^\s]*).*/, "$1") + ' ...';
        }
        imgAltDiv.innerHTML = products[i].name;
        imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";
        noResultsHtml += '<div class="kuNoResultsImgWrap-lp">';
        noResultsHtml += '<img src="' + products[i].imageUrl + '" onerror="this.onerror=null;this.src=\'' +
          klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '"/></div>';

        noResultsHtml += '<div class="kuProduct-desc">';
        noResultsHtml += '<div class="ku-name">' + products[i].name + '</div>';
        noResultsHtml += '<div class="ku-desc">' + products[i].desc + '</div>';

        noResultsHtml += '</div>';

        if (klevu_showPrices) {
            noResultsHtml += '<div class="kuPrice ge-hide">';
            if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
              noResultsHtml += klevu_commons.showOriginalAndSalePrices('LANDING', products[i],
                'kuSalePrice', 'kuSalePrice kuSpecialPrice');
            } else {
              noResultsHtml += klevu_commons.showProductPrices('LANDING', products[i],
                'kuSalePrice', 'kuSalePrice kuSpecialPrice');
            }
            noResultsHtml += '</div>';
          
        }
        if (products[i].totalProductVariants && products[i].totalProductVariants != '0') {
          noResultsHtml += '<div class="kuVariants">+' + products[i].totalProductVariants +
            ' ' + klevu_uiLabels.variants + '</div>';
        }
        noResultsHtml += '<div class="klevu-clear-left"></div>'
        noResultsHtml += '</a> </li>';

      }
      noResultsHtml += '</ul>';
      noResultsHtml += '</div>';
    }

    if (noResultsData.banner && noResultsData.banner.showOnLandingPage) {
      trackingParams = '{' +
        'id: \'' + noResultsData.banner.bannerRef + '\',' +
        'name: \'' + noResultsData.banner.bannerName + '\',' +
        'image: \'' + escape(noResultsData.banner.bannerImageUrl) + '\',' +
        'redirectUrl: \'' + noResultsData.banner.redirectUrl + '\'' +
        '}';

      if (klevu_commons.isMobileDevice()) {
        trackingEvent = ' onclick=';
      } else {
        trackingEvent = ' onclick="klevu_analytics.stopClickDefault( event );" ' +
          ' onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + trackingParams + ', klevu_analytics.trackClickedBannerAds);" ' +
          ' onmousedown=';
      }
      trackingEvent += '"return klevu_analytics.trackClickedBannerAds(event, ' + trackingParams + ');" target="_blank">';


      noResultsHtml += '<div class="kuNoResults-lp-banner"><a href="' + noResultsData.banner.redirectUrl + '" ' + trackingEvent +
        '<img src="' + noResultsData.banner.bannerImageUrl + '" alt="' + noResultsData.banner.bannerName + '"/></a></div>';
    }

    if ((noResultsOptions && noResultsOptions.showPopularKeywords) ||
      (klevu_userOptions.showPopularKeywordsForNoResult)) {
      showPopularKeywords = true;
    }
    if ('undefined' !== typeof klevu_webstorePopularTerms && klevu_webstorePopularTerms && showPopularKeywords) {
      var psList = klevu_webstorePopularTerms,
        count = 1;
      noResultsHtml += '<div class="kuNoResults-lp-pSearch">';
      noResultsHtml += '<strong class="kuNoResults-lp-pSearch-title">' + klevu_uiLabels.popularSearches + ' </strong>';
      if (psList && psList.length > 0) {
        for (i = 0; i < psList.length; i++) {
          if (i !== 0) {
            noResultsHtml += ", ";
          }
          try {
            noResultsHtml += '<a href="' + noResultsData.landingPageUrl +
              encodeURIComponent(decodeURIComponent(psList[i])) + '">' +
              decodeURIComponent(psList[i]) + '</a>';
          } catch (e) {
            continue;
          }
          if (count === 5) {
            break;
          }
          count++;
        }
      }
      noResultsHtml += '</div>';
    }
    noResultsHtml += '</div>';
    noResultsHtml += '</div>';
    return noResultsHtml;
  },

  /**
   * function for rendering quick search products
   */
  showAutocompleteProducts: function (product) {
	//get vip price
  	var vippercentagestr = "";
    var viptagarray = product.tags.split(',');
    var vipsalemultiplier = 0;
    for(var b = 0; b < viptagarray.length; b++){
      if(viptagarray[b].indexOf("VIPSale") > -1){
    	vippercentagestr = viptagarray[b].split(' ')[2];
    	vipsalemultiplier = 1 - (parseInt(vippercentagestr) / 100);
        break;
	  }
    }
	
    var productHtml = '',
      trackingParams = '',
      imgAlt,
      imgAltDiv = document.createElement('div');
    product = klevu_productCustomizations(product);
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }
    
    product.productUrl = product.productUrl + "?subnav=Search";
    
    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
    }
    trackingParams = '{' +
      'data: {' +
      'code: \'' + escape(product.productCode) + '\',' +
      'url: \'' + escape(product.productUrl) + '\',' +
      'name: \'' + escape(product.productName) + '\',' +
      'salePrice: \'' + escape(product.salePrice) + '\',' +
      'rating: \'' + escape(product.rating) + '\',' +
      'position: ' + product.productPosition + ',' +
      'category: \'' + escape(product.category) + '\',' +
      'sku: \'' + escape(product.sku) + '\'' +
      '}' +
      '}';
    imgAltDiv.innerHTML = product.productName;
    imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";
    productHtml += '<li>';
    productHtml += '<a href="' + product.productUrl.replace(/"/g, "%22") + '" class="klevu-result-box-l2" ';
    if (klevu_commons.isMobileDevice()) {
      productHtml += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');"  >';
    } else {
      productHtml += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' +
        ' onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + trackingParams + ', klevu_analytics.trackClickedProduct);" ' +
        additionalParams + ' >';
    }

    // PRODUCT THUMBNAIL
    productHtml += '<div class="klevu-img-wrap-l2"><img src="' + product.productImage +
      '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl +
      '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '" /></div>';

    // DISCOUNT BADGE
    if ('undefined' !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge && product.discount != '' &&
      product.discount != '0' && product.discount != '0.0') {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        productHtml += '<div class="klevu-discount-badge-l2">' +
          klevu_uiLabels.discountBadgeText + ' ' + Number(product.discount).toFixed(0) +
          '%</div>';
      } else {
        productHtml += '<div class="klevu-discount-badge-l2">' +
          klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
          '</div>';

      }
    }

    // PRODUCT NAME & DESCRIPTION
    productHtml += '<div class="klevu-name-desc-l2">';
    productHtml += '<div class="klevu-name-l2">' + product.productName + '</div>' +
      '<div class="klevu-desc-l2">' + product.productDescription + '</div>';

    // PRODUCT PRICES
    if (klevu_showPrices) {
      // PRODUCT PRICE
      if(peValidateVIP() && vipsalemultiplier != 0){
        var vipmardownprice = product.salePrice * vipsalemultiplier;
        productHtml += '<div class="klevu-price-l2 ge-hide">';
        productHtml += '<span class="klevu-saleprice-l2">'
        productHtml += '<span class="klevuPriceGreyText-l2" style="text-decoration: line-through;">&pound;' + product.salePrice + '</span>';
        productHtml += '<span style="color:red;margin-left:5px;">&pound;' + vipmardownprice.toFixed(2) + '</span>';
        productHtml += '</span>';
        productHtml += '</div>';
      }
      else{
        productHtml += '<div class="klevu-price-l2 ge-hide">';
        if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
          productHtml += klevu_commons.showOriginalAndSalePrices('SLIM', product, 'klevu-saleprice-l2',
            'klevu-saleprice-l2 klevu-special-price-l2');
        } else {
          productHtml += klevu_commons.showProductPrices('SLIM', product, 'klevu-saleprice-l2',
            'klevu-saleprice-l2 klevu-special-price-l2');
        }
        if (klevu_userOptions.vatCaption.trim().length > 0) {
          productHtml += '<span class="klevu-vat-caption-l2">(' +
            klevu_userOptions.vatCaption + ')</span>';
        }
        productHtml += '</div>';
      }
    }

    // PRODUCT RATING
    if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
      Number(product.rating) <= 5 && Number(product.rating) >= 0) {
      var starWidth = 20 * Number(product.rating);
      productHtml += '<div class="klevu-stars-small-l2">' +
        '<div class="klevu-rating-l2" style="width:' + starWidth +
        '%;"></div></div>';
    }

    // OUT OF STOCK LABEL
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if (product.inStock && product.inStock === 'no') {
        productHtml += '<div class="klevu-out-of-stock-l2">' +
          klevu_userOptions.outOfStockCaption + '</div>';
      }
    }
    productHtml += '</div><div class="klevu-clear-left"></div></a></li>';
    return productHtml;
  },

  displayNoResultData: function (noResultsData) {
    if (!noResultsData.msgToShow) {
      noResultsData = klevu_commons.getNoResultsData(klevu_uiLabels.noRecords, noResultsData);
    }
    var noResultsHtml = '',
      maxNoOfChars = 33,
      products = noResultsData.products || [],
      noResultsOptions = klevu_userOptions.noResultsOptions,
      showPopularKeywords = false,
      imgAlt,
      imgAltDiv = document.createElement('div');

    noResultsHtml += '<div class="klevuSearchNoResults-Inner">';
    noResultsHtml += '<div class="klevuNoResults-message" >' + noResultsData.msgToShow + '</div>';

    if (products && products.length > 0) {

      noResultsHtml += '<div class="klevuSearchNoResultsBlock">';
      noResultsHtml += '<div class="klevuSearchNoResults-l2">';
      noResultsHtml += '<div class="klevuSearchNoResultsHeading">' + noResultsData.headingForNoResultProducts + '</div>';
      noResultsHtml += '<ul>';

      for (var i = 0; i < products.length; i++) {

        noResultsHtml += '<li>';
        noResultsHtml += '<a href="' + products[i].url + '" class="klevu-noResultsBox-l2"';
        if (klevu_commons.isMobileDevice()) {
          noResultsHtml += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + noResultsData.trackingParams[i] + ');"  >';
        } else {
          noResultsHtml += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + noResultsData.trackingParams[i] + ');" ' +
            ' onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + noResultsData.trackingParams[i] + ', klevu_analytics.trackClickedProduct);" ' +
            noResultsData.additionalParams + ' >';
        }

        if (('undefined' === typeof klevu_truncateDescription ||
            ('undefined' !== typeof klevu_truncateDescription && klevu_truncateDescription)) &&
          products[i].desc.length > maxNoOfChars) {
          products[i].desc = products[i].desc.replace(/^(.{33}[^\s]*).*/, "$1") + ' ...';
        }
        imgAltDiv.innerHTML = products[i].name;
        imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";
        noResultsHtml += '<div class="klevu-img-wrap-l2">';
        noResultsHtml += '<img src="' + products[i].imageUrl +
          '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl +
          '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '" /></div>';
        //noResultsHtml += '<div class="klevu-discount-badge-l2"><strong>20%</strong> off</div>';
        noResultsHtml += '<div class="klevu-name-desc-l2">';
        noResultsHtml += '<div class="klevu-name-l2">' + products[i].name + '</div>';
        noResultsHtml += '<div class="klevu-desc-l2">' + products[i].desc + '</div>';

        if (klevu_showPrices) {
            noResultsHtml += '<div class="klevu-price-l2">';
            if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
              noResultsHtml += klevu_commons.showOriginalAndSalePrices('SLIM', products[i], 'klevu-saleprice-l2',
                'klevu-saleprice-l2 klevu-special-price-l2');
            } else {
              noResultsHtml += klevu_commons.showProductPrices('SLIM', products[i], 'klevu-saleprice-l2',
                'klevu-saleprice-l2 klevu-special-price-l2');
            }
            //noResultsHtml += '<span class="klevu-vat-caption-l2">+ Vat</span>';
            noResultsHtml += '</div>';
        }
        //noResultsHtml += '<div class="klevu-stars-small-l2"><div class="klevu-rating-l2"></div></div>'
        //noResultsHtml += '<div class="klevu-out-of-stock-l2">Out of stock</div>';
        noResultsHtml += '</div>';
        noResultsHtml += '<div class="klevu-clear-left"></div>';
        noResultsHtml += '</a>';
        noResultsHtml += '</li>';
      }
      noResultsHtml += '</ul>';
      noResultsHtml += '</div>';
      noResultsHtml += '</div>';
    }

    if (noResultsData.banner && noResultsData.banner.showOnQuickSearch) {
      trackingParams = '{' +
        'id: \'' + noResultsData.banner.bannerRef + '\',' +
        'name: \'' + noResultsData.banner.bannerName + '\',' +
        'image: \'' + escape(noResultsData.banner.bannerImageUrl) + '\',' +
        'redirectUrl: \'' + noResultsData.banner.redirectUrl + '\'' +
        '}';

      if (klevu_commons.isMobileDevice()) {
        trackingEvent = ' onclick=';
      } else {
        trackingEvent = ' onclick="klevu_analytics.stopClickDefault( event );" ' +
          ' onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + trackingParams + ', klevu_analytics.trackClickedBannerAds);" ' +
          ' onmousedown=';
      }
      trackingEvent += '"return klevu_analytics.trackClickedBannerAds(event, ' + trackingParams + ');" target="_blank">';


      noResultsHtml += '<div class="kuNoResults-banner"><a href="' + noResultsData.banner.redirectUrl + '" ' + trackingEvent +
        '<img src="' + noResultsData.banner.bannerImageUrl + '" alt="' + noResultsData.banner.bannerName + '"/></a></div>';
    }

    if ((noResultsOptions && noResultsOptions.showPopularKeywords) ||
      (klevu_userOptions.showPopularKeywordsForNoResult)) {
      showPopularKeywords = true;
    }
    if ('undefined' !== typeof klevu_webstorePopularTerms && klevu_webstorePopularTerms && showPopularKeywords) {
      var psList = klevu_webstorePopularTerms,
        count = 1;
      noResultsHtml += '<div class="klevuNoResults-pSearch">';
      noResultsHtml += '<strong class="klevuNoResults-pSearchTitle">' + klevu_uiLabels.popularSearches + ' </strong>';

      if (psList && psList.length > 0) {
        for (i = 0; i < psList.length; i++) {
          if (i !== 0) {
            noResultsHtml += ", ";
          }
          try {
            noResultsHtml += '<a href="' + noResultsData.landingPageUrl +
              encodeURIComponent(decodeURIComponent(psList[i])) + '">' +
              decodeURIComponent(psList[i]) + '</a>';
          } catch (e) {
            continue;
          }
          if (count == 5) {
            break;
          }
          count++;
        }
      }
      noResultsHtml += '</div><!-- ends klevuNoResults-popularSearch-->';
    }
    noResultsHtml += '</div><!-- ends klevuNoResults-Inner-->';
    return noResultsHtml;
  }
}


/**
 * This function is called after the landing page results are loaded.
 * Customers can include this function on their site 
 * to perform any action that they need after the results are loaded.
 */
function klevu_afterLandingResultsLoaded(results) {
  if (results.length <= 0) {
    return;
  }

  // fire any function here
}